const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector('.main-search__input');
    this.resultsBox = this.querySelector('.main-search__results');
    this.closeBtn = this.querySelector('.main-search__close');
    this.oldSearchValue = '';
    this.searchTimeoutID = -1;
    this.searchAbortController = null;
    this.resultLimit = 4;
    this.includeMeta = this.dataset.quickSearchMeta === 'true';
    this.searchTimeoutThrottle = 500;

    // Eventos
    this.bindEvents();

    // Búsqueda rápida
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  bindEvents() {
    // Botón cerrar
    this.closeBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeSearch();
    });

    // Tecla Escape
    this.searchInput?.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.closeSearch();
      }
    });

    // Click fuera para cerrar
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeSearch();
      }
    });
  }

  openSearch() {
    document.body.classList.add('show-search');
  }

  closeSearch() {
    document.body.classList.remove('show-search');
    this.resultsBox.innerHTML = '';
    this.classList.remove('main-search--has-results', 'main-search--no-results', 'main-search--loading');
  }

  initQuickSearch() {
    const handler = this.handleInputChange.bind(this);
    this.searchInput.addEventListener('keyup', handler);
    this.searchInput.addEventListener('change', handler);
  }

  handleInputChange() {
    const valueToSearch = this.searchInput.value.trim();

    if (valueToSearch.length < 2 || valueToSearch === this.oldSearchValue) return;

    this.oldSearchValue = valueToSearch;
    this.openSearch();

    // Cancelar búsqueda previa
    clearTimeout(this.searchTimeoutID);
    if (this.searchAbortController) {
      this.searchAbortController.abort();
    }

    // Mostrar loading
    this.classList.remove('main-search--has-results', 'main-search--no-results');
    this.classList.add('main-search--loading');
    this.resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';

    // Ejecutar nueva búsqueda
    this.searchTimeoutID = setTimeout(() => {
      this.doSearch(valueToSearch);
    }, this.searchTimeoutThrottle);
  }

  doSearch(value) {
    const form = this.searchInput.closest('form');
    const linkURL = new URL(form.action, window.location.origin);
    const formParams = new URLSearchParams(new FormData(form));
    formParams.forEach((val, key) => linkURL.searchParams.set(key, val));

    this.searchAbortController = new AbortController();

    const ajaxUrl = theme?.Shopify?.features?.predictiveSearch
      ? new URL(theme.routes.base + theme.routes.predictiveSearch)
      : new URL(linkURL);

    if (theme?.Shopify?.features?.predictiveSearch) {
      ajaxUrl.searchParams.set('q', value);
      ajaxUrl.searchParams.set('section_id', 'predictive-search');
      ajaxUrl.searchParams.set('resources[limit]', this.resultLimit);
      ajaxUrl.searchParams.set('resources[options][fields]', this.includeMeta
        ? 'title,product_type,variants.title,vendor,tag,variants.sku'
        : 'title,product_type,variants.title,vendor');
    } else {
      ajaxUrl.searchParams.set('section_id', 'main-search');
    }

    fetch(ajaxUrl, { method: 'GET', signal: this.searchAbortController.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`Error ${res.status}`);
        return res.text();
      })
      .then((html) => this.renderResults(html, linkURL))
      .catch((err) => {
        if (err.name !== 'AbortError') console.warn('Search failed:', err);
      });
  }

  renderResults(html, fullResultsURL) {
    this.searchAbortController = null;
    const template = document.createElement('template');
    template.innerHTML = html;

    const resultsList = template.content.querySelector('.product-grid');
    this.resultsBox.innerHTML = '';
    this.classList.remove('main-search--loading');

    if (!resultsList || !resultsList.querySelector('.product-block')) {
      this.classList.add('main-search--no-results');
      const msg = document.createElement('div');
      msg.className = 'main-search__empty-message';
      msg.textContent = theme.strings.generalSearchNoResultsWithoutTerms;
      this.resultsBox.appendChild(msg);
      return;
    }

    const resultsProducts = document.createElement('div');
    resultsProducts.className = 'main-search__results__products collection-listing';
    resultsProducts.innerHTML = `<div class="${resultsList.className}"></div>`;

    resultsList.querySelectorAll('.product-block:not(.page-block)').forEach((block, i) => {
      if (i < this.resultLimit) {
        block.classList.add('main-search-result');
        block.querySelectorAll('.btn.quickbuy-toggle')?.forEach((btn) => btn.remove());
        resultsProducts.firstElementChild.appendChild(block);
      }
    });

    this.resultsBox.appendChild(resultsProducts);

    const allLink = document.createElement('a');
    allLink.className = 'main-search__results-all-link btn btn--secondary';
    allLink.href = fullResultsURL.toString();
    allLink.textContent = theme.strings.generalSearchViewAll;

    this.resultsBox.appendChild(allLink);
    this.classList.add('main-search--has-results');
  }
};

window.customElements.define('main-search', MainSearch);
